import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import CustomListComponent from '../../../components/base/CustomListComponent';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import BaseTabListContainer from '../../base/BaseTabListContainer';
import DeletePrompt from '../../../components/base/DeletePrompt';
import BaseListContainer from '../../base/BaseListContainer';
import { useSelector, useDispatch } from 'react-redux';
import { ActionsDropdownForItem } from '../../../components/base/ActionsDropdown';
import { createAction, getHashKeyString } from '../../../utils';
import { PermissionCodes } from '../../../config/PermissionCodes';
import Filter from './Filter';
import { DELETE_RELATED_SECTIONS } from '../../../config/CustomEnums';
import SpotCheckOverview from '../../../components/spotCheckTransactions/SpotCheckOverview'
import { NavBarNames } from '../../../config/NavBarNameList';
import { TRANSACTION_EVENT_TYPE } from '../records/TransactionList';
import DateRangeSelection from '../../../components/dashboard/DateRangeSelection';
import TransactionActionPrompt from '../../../components/transactions/TransactionActionPrompt';

const TAB_OVERVIEW = 'Overview';
const TAB_LIST_OF_TRANSACTION = 'List of transactions';

function SpotCheckTransactionList() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const activeTab = getHashKeyString(location.hash) || TAB_OVERVIEW;

  const [showDeletePrompt, setShowDeletePrompt] = useState(false);
  const [showActionPrompt, setShowActionPrompt] = useState(false);
  const [promptActionTitle, setPromptActionTitle] = useState();
  const [singleItemAction, setSingleItemAction] = useState(false);
  const [selectedItem, setSelectedItem] = useState();


  const {
    tableFields,
    dataList,
    pageInfo,
    totalCount,
    totalPage,
    currentPage,
    checkedList,
    importedFile,
  } = useSelector((state) => ({
    tableFields: state.spotCheckTransactions.tableFields,
    dataList: state.spotCheckTransactions.transactionList,
    pageInfo: state.spotCheckTransactions.pageInfo,
    totalCount: state.spotCheckTransactions.totalCount,
    totalPage: state.spotCheckTransactions.totalPage,
    currentPage: state.spotCheckTransactions.currentPage,
    checkedList: state.spotCheckTransactions.checkedList,
  }));

  const groupActions = [
    {
      name: 'Delete',
      action: () => {
        setShowDeletePrompt(true);
      },
      requires: PermissionCodes.deleteTransaction,
    },
  ];

  const setActionPrompt = (event, item) => {
    setPromptActionTitle(event);
    setSingleItemAction(true);
    setSelectedItem(item);
    setShowActionPrompt(true);
  };

  const tabs = [
    {
      name: TAB_OVERVIEW,
      content: <SpotCheckOverview />,
    },
    {
      name: TAB_LIST_OF_TRANSACTION,
      content: (
        <BaseTabListContainer
          hideTab={true}
          tabs={[]}
          groupActions={groupActions}
          pageInfo={pageInfo}
          totalCount={totalCount}
          filter={{
            hasFilter: true,
            componment: Filter,
          }}
          listContent={
            <BaseListContainer
              fields={tableFields}
              dataList={dataList}
              totalPage={totalPage ? totalPage : 0}
              model={'spotCheckTransactions'}
              permissionGroup={PermissionCodes.transaction}
              deleteInfo={{
                data: [],
                title: 'spot check transaction',
                relatedName: '',
                relatedSections: DELETE_RELATED_SECTIONS.TRANSACTION,
                onComfirm: {},
              }}
              hasOtherActions={true}
              customActions={{}}
              useCustomCommonActions={true}
              customCommonActions={(item) => {
                let actions = [
                  {
                    name: 'View details',
                    action: () => {
                      return history.push(`/transactions/${item.pk}/`);
                    },
                    requires: PermissionCodes.viewTransaction,
                  },
                  {
                    name: 'Delete',
                    action: () => {
                      setShowDeletePrompt(true);
                      setSingleItemAction(true);
                      setSelectedItem(item);
                    },
                    requires: PermissionCodes.deleteTransaction,
                  },
                ];
                let otherAction = [];
                if (
                  item.displayOfflineEventType ===
                  TRANSACTION_EVENT_TYPE.TYPE_APPROVED
                ) {
                  otherAction = [
                    {
                      name: 'Recall',
                      action: () => {
                        setActionPrompt('recall', item);
                      },
                      requires: PermissionCodes.changeTransaction,
                    },
                  ];
                }
                return (
                  <ActionsDropdownForItem
                    object={item}
                    actions={actions}
                    otherActions={otherAction}
                  />
                );
              }}
            />
          }
        />
      ),
    }
  ];

  useEffect(() => {
    if (activeTab === TAB_LIST_OF_TRANSACTION) {
      const searchDict = queryString.parse(location.search);
      const searchKey = searchDict['search'] || '';
      const stringRank = searchDict['rank'] || 'true';
      const stringPage = searchDict['page'] || 1;
      const rank = stringRank === 'true';
      const page = parseInt(stringPage);
      dispatch(
        createAction('transactions/getSpotCheckTransactions')({
          ...searchDict,
          searchKey,
          rank,
          page,
        }),
      );
    }
  }, [dispatch, location, activeTab]);

  useEffect(() => {
    createAction('spotCheckTransactions/clearData')({});
    return () => {
      createAction('spotCheckTransactions/clearData')({});
    }
  }, [])

  return (
    <>
      <CustomListComponent
        caution={{
          detail:
            'All spot check transactions are listed here, you can spot check auto approved transactions and transactions approved by cogniac here.',
          title: NavBarNames.spotCheck,
        }}
        defaultActiveKey={activeTab}
        breadcrumb={<CustomBreadcrumb />}
        hideTab={false}
        tabs={tabs}
        onTabChange={(key) => {
          history.push({ pathname: location.pathname, hash: key });
        }}
        renderTabsRight={() => {
          return activeTab === TAB_OVERVIEW ? (
            <DateRangeSelection
              onTab
              applyDateRangeEvent={(startDate, endDate) => {
                dispatch(
                  createAction('overview/getSpotCheckRecordsData')({
                    startDate: startDate.format('YYYY-MM-DD'),
                    endDate: endDate.format('YYYY-MM-DD'),
                  }),
                );
              }}
              clearDataEvent={() => {
                dispatch(createAction('overview/clearState')());
              }}
            />
          ) : null;
        }}
      />
      <DeletePrompt
        show={showDeletePrompt}
        title="Transactions"
        data={singleItemAction ? [selectedItem] : checkedList}
        displayName={'deleteDisplayName'}
        relatedSections={DELETE_RELATED_SECTIONS.TRANSACTION}
        onClose={() => {
          setShowDeletePrompt(false);
        }}
        onConfirm={() => {
          let ids = [];
          if (singleItemAction) {
            ids = [selectedItem.pk];
          } else {
            ids = checkedList.map((item) => {
              return item.pk;
            });
          }
          dispatch(
            createAction('transactions/deleteTransaction')({
              ids,
              afterActions: () => {
                history.push(location);
              },
            }),
          );
          setShowDeletePrompt(false);
        }}
      />
      <TransactionActionPrompt
        event={promptActionTitle}
        item={selectedItem}
        show={showActionPrompt}
        onHide={() => {
          setShowActionPrompt(false);
          setSingleItemAction(false);
        }}
        action={() => {
          dispatch(
            createAction(`transactions/${promptActionTitle}Transaction`)({
              transactionPK: selectedItem.pk,
              afterActions: () => {
                history.push(location);
              },
              ...{}
              ,
            }),
          );
        }}
      />
    </>
  );
}

export default SpotCheckTransactionList;
